// extracted by mini-css-extract-plugin
export default {"btn":"zAvf_Pd3","notes":"l2mhUMjE","mobile":"mobile","description":"GSn0sKM4","text":"WBTKCorI","desktop":"desktop","link":"Y_Jw3asD","close":"nUKgsdK9","more":"Sd3cMPsi"};